import { IHeaderType } from "../../../types/types";
import SectionHeader from "../../../utils/section-header";


type Props = {};

const RowOne = (props: Props) => {

  return (
    <>
      <SectionHeader
        titleText={"Talk to us now"}
        descText={"Reach out, and let's discuss how we can help you succeed. We're ready to answer your questions, listen to your needs, and find the best solutions for your business."}
        type={IHeaderType.h2}
      />
    </>
  );
};

export default RowOne;
